module.exports = __webpack_public_path__ + "static/media/btnCloseRed.88c2a814.svg";